import { render, staticRenderFns } from "./CmgNoLoyaltyForYouModal.vue?vue&type=template&id=3f84a9c8&scoped=true&lang=pug&"
import script from "./cmg-no-loyalty-for-you-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-no-loyalty-for-you-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgNoLoyaltyForYouModal.vue?vue&type=style&index=0&id=3f84a9c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f84a9c8",
  null
  
)

export default component.exports